import BMDB from "../assets/bmdb.png";
import Palnet from "../assets/palnet.png";
import Bol from "../assets/bol.png";
import BolNew from "../assets/bol_new.png";
import Liana from "../assets/lianatrading.png";
import Flow from "../assets/flow.png"
import Erg from "../assets/erg.jpg"

export default function Projects() {
  const projects = [
    {
      id: 1,
      title: "ERG",
      description: "A modern website built with Nextjs",
      image: Erg, // Replace with actual screenshot when available
      link: "https://erg-3d3.pages.dev/",
      tags: ["Nextjs", "Responsive", "UI/UX"],
    },
    {
      id: 2,
      title: "Palnet Website",
      description: "A modern website built with Nextjs",
      image: Palnet, // Replace with actual screenshot when available
      link: "https://palnet.pages.dev/",
      tags: ["React", "API", "Responsive"],
    },
    {
      id: 3,
      title: "BOL Group",
      description: "A modern website built with Nextjs",
      image: Bol, // Replace with actual screenshot when available
      link: "https://bolgroup.pages.dev",
      tags: ["Nextjs", "Responsive"],
    },
    {
      id: 4,
      title: "BOL Website",
      description: "A modern website built with Nextjs",
      image: BolNew, // Replace with actual screenshot when available
      link: "https://bol-8lz.pages.dev/",
      tags: ["Nextjs", "Responsive"],
    },
    {
      id: 5,
      title: "Liana Trading",
      description: "A modern website built with Nextjs",
      image: Liana, // Replace with actual screenshot when available
      link: "https://lianatrading.com/",
      tags: ["Nextjs", "Responsive"],
    },
    {
      id: 6,
      title: "Cycle Tracker",
      description: "A cycle tracker web app built using Nextjs, PHP, MySQL",
      image: Flow, // Replace with actual screenshot when available
      link: "https://newtracker.pages.dev/",
      tags: ["React", "PHP", "API", "MySQL", "UI/UX"],
    },
    {
      id: 7,
      title: "Movie IMDB",
      description: "A modern movie database application built with React",
      image: BMDB, // Replace with actual screenshot when available
      link: "https://bmdb.pages.dev/",
      tags: ["React", "API", "Responsive"],
    },
  ];

  return (
    <section
      id="projects"
      className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto"
    >
      <div className="space-y-16">
        {/* Header */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold text-gray-900">My Projects</h1>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <a
              key={project.id}
              href={project.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 aspect-video bg-gradient-to-br from-blue-50 to-blue-100"
            >
              {/* Project Image */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-blue-600">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Overlay Content */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                <h3 className="text-xl font-bold text-white mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  {project.title}
                </h3>
                <p className="text-sm text-gray-200 mb-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-75">
                  {project.description}
                </p>
                <div className="flex flex-wrap gap-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 delay-100">
                  {project.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-1 text-xs bg-white/20 backdrop-blur-sm text-white rounded-full border border-white/30"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {/* Always Visible Title (Bottom) */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 group-hover:opacity-0 transition-opacity duration-300">
                <h3 className="text-lg font-semibold text-white">
                  {project.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
